import React from 'react'
import Input from 'components/Form/Input'
import Flex from 'components/Flex'
import AuthoriseIcon from 'components/icons/AuthoriseIcon'
import Download from 'components/icons/Download'
import EyeIcon from 'components/icons/EyeIcon'
import CheckCircleIcon from 'components/icons/CheckCircleIcon'
import {
  ComanyDiv,
  AuthorityDiv,
  AuthSubTitleDiv,
  TextVerified,
  AuthoFlex,
  FlexAuth,
  CommonFlex,
  SubTitleDiv,
  RightSection,
  MainWrapper,
  PopoverImg,
  PreviewDiv,
  DownLoadDiv,
} from 'modules/Settings/Components/TaxInfo/style'
import { Popover, Tooltip } from 'antd'
import { getFileSize } from 'utils/getFileSize'

const TaxInfo = ({ instituteData, settingsForm, selectedTab }) => {
  const isTaxInfoTab = selectedTab === "TAXINFO"; // Determine if the selected tab is "TAXINFO"
  return (
    <MainWrapper>
      <ComanyDiv>Tax Information</ComanyDiv>
      <CommonFlex spaceBetween>
        <SubTitleDiv>PAN Number *</SubTitleDiv>
        <RightSection>
          <Input
            placeholder="Enter PAN number"
            width="100%"
            name="companyPAN"
            maxLength={20}
            rules={
              isTaxInfoTab
                ? [
                    {
                      required: true,
                      message: "Please enter PAN number",
                    },
                    {
                      min: 10,
                      max: 10,
                      message: "Please Enter Valid PAN Number",
                    },
                  ]
                : [] // No validation rules if not TAXINFO
            }
          />
        </RightSection>
      </CommonFlex>
      <CommonFlex spaceBetween>
        <SubTitleDiv>GST Number *</SubTitleDiv>
        <RightSection>
          <Input
            placeholder="Enter GST number"
            width="100%"
            name="companyGST"
            maxLength={25}
            rules={
              isTaxInfoTab
                ? [
                    {
                      required: true,
                      message: "Please enter GST number",
                    },
                    {
                      min: 15,
                      max: 15,
                      message: "Please Enter Valid GST Number",
                    },
                  ]
                : [] // No validation rules if not TAXINFO
            }
          />
        </RightSection>
      </CommonFlex>
      <CommonFlex spaceBetween>
        <SubTitleDiv>Authorized Signatory</SubTitleDiv>
        {instituteData?.authorisedSignatory ? (
          <RightSection>
            <FlexAuth spaceBetween>
              <AuthoFlex>
                <AuthoriseIcon />
                <Flex column>
                  <Tooltip title={instituteData?.authorisedSignatory?.name}>
                    <AuthorityDiv>
                      {(instituteData?.authorisedSignatory?.name?.length > 32
                        ? instituteData?.authorisedSignatory?.name.substr(
                            0,
                            32
                          ) + "..."
                        : instituteData?.authorisedSignatory?.name) || "-"}
                    </AuthorityDiv>
                  </Tooltip>
                  <AuthSubTitleDiv>
                    {instituteData?.authorisedSignatory?.type} |{" "}
                    {getFileSize(6420)}
                  </AuthSubTitleDiv>
                </Flex>
              </AuthoFlex>
              <Flex centerVertically>
                <CheckCircleIcon />
                <TextVerified>Verified</TextVerified>
                <Popover
                  getPopupContainer={() =>
                    document.getElementById(`sinatoryFile`)
                  }
                  content={
                    <PopoverImg src={instituteData?.authorisedSignatory?.url} />
                  }
                  trigger="hover"
                >
                  <PreviewDiv id={'sinatoryFile'}>
                    <EyeIcon />
                  </PreviewDiv>
                </Popover>
                <DownLoadDiv
                  href={instituteData?.authorisedSignatory?.url}
                  downLoad
                  target="_blank"
                >
                  <Download />
                </DownLoadDiv>
              </Flex>
            </FlexAuth>
          </RightSection>
        ) : (
          <RightSection>
            <AuthorityDiv>No File Added</AuthorityDiv>
          </RightSection>
        )}
      </CommonFlex>
    </MainWrapper>
  )
}

export default TaxInfo
